import { ref } from 'vue';
import type { IPageOptions } from '@/types';

const defaultPageOptions: IPageOptions = {
    itemsPerPage: 50,
    page: 1,
    rowsPerPageItems: [50, 100, 200, 400],
    sortBy: [{ key: 'name', order: 'asc' }],
};

export function usePageOptions(overrides: Partial<IPageOptions> = {}) {
    return ref<IPageOptions>({
        ...defaultPageOptions,
        ...overrides,
    });
}
